import Work1 from "../../assets/trulioo-logo.png";
import Work2 from "../../assets/cutlery-svgrepo-com.svg";
// import Work3 from "../../assets/zip-file-svgrepo-com.svg";
import Work3 from "../../assets/eventBooker.svg";


const Menu = [
    {
      id: 1,
      image: Work3,
      title: "EasyEvent Booker",
      category: "Full-Stack Application",
      href: "https://github.com/kenth727/EventBooker",
      desc: "A full-stack event management app with JWT auth, built using React, Node.js, GraphQL, and MongoDB. Features event creation, booking, and a responsive UI."
    },
    {
      id: 2,
      image: Work1,
      title: "Business Document Parser",
      category: "AI & Machine Learning",
      href: "https://www.trulioo.com/",
      desc: "A tool leveraging GPT-4 API and Google Cloud DocumentAI to extract, classify, and summarize business-critical data from scanned documents, improving operational efficiency."
    },
    {
      id: 3,
      image: Work2,
      title: "Restaurant Finder",
      category: "Mobile & Front-End Development",
      href: "https://github.com/k521/RestaurantFinder",
      desc: "A mobile application that provides health inspection ratings for restaurants in Surrey, utilizing real-time location-based services to enhance decision-making for users."
    },
  ];

export default Menu